// @flow
import {calcRowEndIndex} from './calcRowEndIndex';
import {validateRowEndIndex} from './validateRowEndIndex';
import {SCROLL_DIRECTION} from '../constants';

type Params = {|
    scrollOffset: number,
    rowsCount: number,
    rowsOffset: Array<number>,
    direction: $Values<typeof SCROLL_DIRECTION>,
    overscanRows?: number,
    viewportHeight?: number,
|};

export const getRowEndIndex = (param: Params): number => {
    const {scrollOffset, viewportHeight, overscanRows, rowsCount, rowsOffset, direction} = param;
    const validatedOverscanRows = direction === SCROLL_DIRECTION.down ? overscanRows : 0;
    const rowEndIndex = calcRowEndIndex({
        scrollOffset,
        viewportHeight,
        overscanRows: validatedOverscanRows,
        rowsOffset
    });
    return validateRowEndIndex({rowsCount, rowEndIndex});
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../constants");
